
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import FormRadioButton from './form-radio-button'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formradiobutton"
    }}>{`FormRadioButton`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "radio-button"
    }}>{`Radio button`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For a set of related options. In a group of radio inputs, only one may be selected.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<FormRadioButton labelText=\"Input text\" id=\"radioButton\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormRadioButton
    }} mdxType="Playground">
  <FormRadioButton labelText="Input text" id="radioButton" mdxType="FormRadioButton" />
    </Playground>
    <p><strong parentName="p">{`Selected`}</strong></p>
    <Playground __position={2} __code={'<FormRadioButton labelText=\"Input text\" id=\"radioSelected\" defaultChecked />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormRadioButton
    }} mdxType="Playground">
  <FormRadioButton labelText="Input text" id="radioSelected" defaultChecked mdxType="FormRadioButton" />
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={3} __code={'<FormRadioButton labelText=\"Input text\" id=\"radioDisabled\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormRadioButton
    }} mdxType="Playground">
  <FormRadioButton labelText="Input text" id="radioDisabled" disabled mdxType="FormRadioButton" />
    </Playground>
    <p><strong parentName="p">{`Selected and disabled`}</strong></p>
    <Playground __position={4} __code={'<FormRadioButton\n  labelText=\"Input text\"\n  id=\"radioSelectedDisabled\"\n  disabled\n  defaultChecked\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormRadioButton
    }} mdxType="Playground">
  <FormRadioButton labelText="Input text" id="radioSelectedDisabled" disabled defaultChecked mdxType="FormRadioButton" />
    </Playground>
    <p><strong parentName="p">{`Other use-cases`}</strong></p>
    <Playground __position={5} __code={'<FormRadioButton labelText=\"A radio button...\" id=\"other-1\" />\n<br />\n<FormRadioButton\n  labelText=\"Side-by-side another one with a lot of text which should wrap when needed\"\n  id=\"other-2\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      FormRadioButton
    }} mdxType="Playground">
  <FormRadioButton labelText="A radio button..." id="other-1" mdxType="FormRadioButton" />
  <br />
  <FormRadioButton labelText="Side-by-side another one with a lot of text which should wrap when needed" id="other-2" mdxType="FormRadioButton" />
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormRadioButton} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;